import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CxMenuModule } from '@bbraun/cortex/menu';
import { CxProfileDropdownComponent } from '@bbraun/cortex/profile-dropdown';
import { TranslocoDirective } from '@jsverse/transloco';
import { OAuthService } from 'angular-oauth2-oidc';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header-profile',
  imports: [
    CommonModule,
    CxProfileDropdownComponent,
    CxMenuModule,
    TranslocoDirective
  ],
  templateUrl: './header-profile.component.html',
  styleUrl: './header-profile.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HeaderProfileComponent {
  private readonly oAuthService = inject(OAuthService);

  protected readonly claimedIdentity = this.oAuthService.getIdentityClaims();

  public onLogout(): void {
    this.oAuthService.logOut();
  }

  public onProfile(): void {
    window.open(environment.profile, '_blank');
  }
}
